const create = () => ({
  start: () => Promise.resolve(),
  cancel: () => Promise.resolve(),
});

export const myAccount = {
  name: '@feature/myaccount-mock',
  create,
  dependsOn: [],
  role: 'my-account',
};
